import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants.js'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants.js'

// Storybook mock

export const UserDataChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

// Top navigation main

export const TopNavigationContainer = styled.div`
  display: grid;
  height: 48px;
  padding: 0.5rem 1rem;
  row-gap: 0.5rem;
  column-gap: 0.5rem;
  flex: 1 0 0;
  grid-template-rows: repeat(1, minmax(0, 1fr));
  grid-template-columns: repeat(2, minmax(0, 1fr));
  background-color: ${colorsOptions.greys['grey-100']};
`

export const RightElementsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  grid-row: 1 / span 1;
  grid-column: 2 / span 1;
`

export const LeftElementsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  grid-row: 1 / span 1;
  grid-column: 1 / span 1;
`

export const LogoContainer = styled.div`
  display: flex;
  padding: 8px 0 5px 0;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  flex-shrink: 0;
`

// Components

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const ImageLogo = styled.img`
  width: 100%;
  max-width: 120px;
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

// Quick select

export const QuickSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  max-width: fit-content;
`

export const QuickSelectionLabelContainer = styled.div`
  display: flex;
  padding: 0.25rem;
  align-items: center;
  gap: 0.5rem;
  font-variant-numeric: lining-nums proportional-nums;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  font-weight: 600;
  line-height: 18.2px; /* 130% */
  letter-spacing: 0.2px;
  color: ${colorsOptions.greys.white};
  border-radius: 4px;
  min-width: 0;
  max-width: 100%;

  &:hover {
    background: ${colorsOptions.greys['grey-80']};
  }

  &:active {
    background: ${colorsOptions.greys['grey-70']};
  }

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  `};
`

export const QuickSelectText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const QuickSelectListContainer = styled.div`
  transform: translateY(8px);
`

export const QuickSelectListContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${colorsOptions.greys.white};
  position: relative;
`

export const SearchContainer = styled.div`
  background-color: ${colorsOptions.greys.white};
  top: 0;
  position: sticky;
  width: 100%;
  z-index: 2;
`
export const FolderContentContainer = styled.div`
  width: 100%;
  padding-left: 1rem;
`

export const RecursiveItemTitle = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.greys['grey-100']};

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const RecursiveItemContainer = styled.div`
  width: 100%;
  height: 32px;
  padding: 0 1rem;
  gap: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &:hover {
    background: ${colorsOptions.greys['grey-05']};
  }

  &:active {
    background: ${colorsOptions.greys['grey-10']};
  }

  &[data-selected='true'] {
    background: ${colorsOptions.greys['grey-10']};
    ${RecursiveItemTitle} {
      ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
    }
  }
`

export const ChildrenLoadingContainer = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.greys['grey-100']};

  gap: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 32px;
  padding: 0 1rem;
`

export const EmptyFolderText = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.greys['grey-100']};

  text-transform: lowercase;

  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 1rem;
`

export const EmptyData = styled.div`
  padding: 3rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const RecursiveListItemContainer = styled.div`
  width: 100%;
  z-index: 1;
`

// User menu

export const UserAvatarContainer = styled(IconContainer)`
  cursor: pointer;
  padding: 0.5rem;

  transition:
    transform 300ms ease-out,
    opacity 300ms ease-out;

  &:hover {
    transform: scale(1.2);
    opacity: 0.9;
  }
`

export const UserDataContainer = styled.div`
  width: 100%;
  padding: 1rem 1rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`

export const UserName = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-70']};
  text-transform: uppercase;
`

// Search

export const GlobalSearchTabContainer = styled.div`
  display: flex;
  min-height: 32px;
  padding: 4px 0;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`

export const NotFoundContainer = styled.div`
  display: flex;
  padding: 40px 0;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`

export const NotFoundHeader = styled.span`
  color: ${colorsOptions.greys['grey-50']};
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  /* 700 (bold)/700-R */
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};

  font-style: normal;
  font-weight: 700;
  line-height: 18.2px; /* 130% */
  letter-spacing: 0.2px;
  margin-bottom: 0.5rem;
`

export const NotFoundHDescription = styled.span`
  color: ${colorsOptions.greys['grey-50']};
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  /* 700 (bold)/700-R */
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};

  font-style: normal;
  font-weight: 500;
  line-height: 20.8px; /* 130% */
  letter-spacing: 0.2px;
`

// Notification menu

export const NotificationMenuLabelContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ top }) => (top ? `0.5rem 0 0 0` : `0rem 1rem 0.5rem 0`)};
  width: 100%;
  justify-content: space-between;
`

export const NotificationMenuLabel = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-70']};
  text-transform: uppercase;
  padding: 1rem;
`

export const NotificationSubMenuLabel = styled(NotificationMenuLabel)`
  padding: 1rem 1rem 0.5rem;
`

export const NotificationMenuLabelContainerNoPadding = styled(
  NotificationMenuLabelContainer
)`
  padding: 0;
`

export const BoldSpan = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
`

export const NormalSpan = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
`

export const NotificationDateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.25rem;
`

export const NotificationDot = styled.span`
  width: 10px;
  height: 10px;
  background-color: ${colorsOptions.secondaryColors.orange.normal};
  border-radius: 50%;
  transform: translateY(-1px);
`

export const UserDataContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const UserDataName = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  color: ${colorsOptions.greys.white};
  padding-top: 0.5rem;
`

export const UserDataCompany = styled(UserDataName)`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  padding: 0;
`

export const LoadingContainer = styled.div`
  padding: 80px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const EllipseText = styled.div`
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

// User Menu expired flag
export const ExpiredFlag = styled.div`
  width: 100%;
  &::before {
    content: '';
    position: absolute;
    top: 6px;
    right: 6px;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    z-index: 2;
    outline: 2px solid ${colorsOptions.greys['grey-100']};
  }

  &:hover {
    transform: scale(1.2);
    opacity: 0.9;
  }
`

// Notifications

export const NotificationsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const NotificationListContainer = styled.div`
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  min-height: 160px;
`
